import { ReactNode } from 'react';
import { Icon, IconName } from './Icon';

export function EmptyState({
  icon = 'family',
  title,
  children,
}: {
  icon?: IconName;
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      <span className="text-hs-text-mute mb-3">
        <Icon name={icon} size={40} strokeWidth={1.75} />
      </span>
      <h2 className="font-display font-semibold text-[20px] text-hs-text">{title}</h2>
      {children && <p className="mt-1.5 max-w-xs text-[13.5px] text-hs-text-mute">{children}</p>}
    </div>
  );
}
